export default function Envios() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-6">Política de Envíos</h1>

      <h2 className="text-xl font-semibold mb-2">1. Tiempos de entrega</h2>
      <p className="mb-4">
        Los envíos se realizan entre 2 y 7 días hábiles dependiendo de la ciudad destino.
      </p>

      <h2 className="text-xl font-semibold mb-2">2. Costos de envío</h2>
      <p className="mb-4">
        El valor del envío se calcula automáticamente según el operador logístico.
      </p>

      <h2 className="text-xl font-semibold mb-2">3. Seguimiento</h2>
      <p>
        Una vez despachado, recibirás una guía de seguimiento por correo o WhatsApp.
      </p>
    </div>
  );
}
